import { Pipe, PipeTransform } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

/**
 * Pipe with fallback translation
 */
@Pipe({ name: 'translateDefault' })
export class TranslateDefaultPipe implements PipeTransform {
  constructor(private translateService:TranslateService) {/***/
  }

  public transform(value:string, fallback:string):string {
    const ret:string = this.translateService.instant(value);
    if (ret === value) {
      return fallback;
    }
    return ret;
  }
}